export const LOCAL = "local";
export const ADMIN = "admin";
export const USER = "user";
export const DRAWER_WIDTH = 240;
export const PRODUCTION = "production";
export const TRANSPARENCY = 0.8;
export const APP_ID =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkYiI6ImltdGV4MjAyNSIsIm5hbWUiOiJJTVRFWCAyMDI1IiwiaWF0IjoxNzc1NDkzMDc0LCJleHAiOjE4MDcwNTA2NzR9.sE5molxYAK0kBa4Jz8jzeE1NtQXGHWxlHpOPklYWTAY";
export const state = PRODUCTION;
export const API_ENDPOINT =
  state === PRODUCTION
    ? "https://apis.expoplanner.in/" //https://mirrorapis.expoplanner.in/
    : "http://localhost:5002/";

export const TimeZoneIndia = {
  timeZone: "Asia/Kolkata", // IST Timezone
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
};
export const TimeOnlyZone = {
  timeZone: "Asia/Kolkata",
  hour: "2-digit",
  minute: "2-digit",
};
